import { motion } from 'framer-motion'
import { Icon } from './Brand'
import AnimatedNumber from './AnimatedNumber'
import { tintMap } from '../data'

export default function KpiCard({ kpi, index }) {
  const tint = tintMap[kpi.tint]
  return (
    <motion.div
      className="kpi"
      initial={{ opacity: 0, y: 22 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.15 + index * 0.08, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ y: -3, boxShadow: 'var(--sh-md)' }}
    >
      <div className="ic" style={{ background: tint.bg }}>
        <Icon name={kpi.icon} style={{ color: tint.fg }} />
      </div>
      {kpi.trend && (
        <span className="trend">
          <Icon name="trending_up" />
          {kpi.trend}
        </span>
      )}
      <div className="val">
        {kpi.value == null ? (
          <span>{kpi.placeholder || '—'}</span>
        ) : (
          <>
            <AnimatedNumber value={kpi.value} decimals={kpi.decimals} prefix={kpi.prefix || ''} delay={0.2 + index * 0.08} />
            {kpi.unit && <span className="unit">{kpi.unit}</span>}
          </>
        )}
      </div>
      <div className="lab">{kpi.label}</div>
      <div className="meta">{kpi.meta}</div>
    </motion.div>
  )
}
